import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DigitalMarketingJobsGhazi = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Digital Marketing Jobs in Ghaziabad  | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest digital marketing jobs in Ghaziabad  NCR. Explore openings for SEO, SEM, social media, and content marketing professionals. Apply for fresher and experienced roles in top companies."
        />
        <meta
          name="keywords"
          content="digital marketing jobs in Ghaziabad , SEO jobs in Ghaziabad , social media marketing jobs in Ghaziabad , SEM jobs in Ghaziabad  NCR, content marketing jobs Ghaziabad , PPC jobs in Ghaziabad , online marketing jobs Ghaziabad , digital marketing executive jobs Ghaziabad , fresher digital marketing jobs Ghaziabad "
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/digitalmarketing-jobs-in-ghaziabad"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Digital Marketing Jobs in Ghaziabad  – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for <strong>digital marketing jobs in Ghaziabad </strong>? Explore
          hundreds of openings in SEO, social media, PPC, and content marketing.
          Whether you’re a fresher or an experienced professional, discover{" "}
          <strong>digital marketing executive</strong> and{" "}
          <strong>manager-level roles</strong> in Ghaziabad  NCR today.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Digital Marketers in Ghaziabad 
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Webchutney</li>
          <li>WATConsult</li>
          <li>AdGlobal360</li>
          <li>iProspect India</li>
          <li>Techmagnate</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular Job Roles in Digital Marketing
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>SEO Executive Jobs in Ghaziabad </li>
          <li>Social Media Manager Jobs in Ghaziabad </li>
          <li>PPC Specialist Jobs in Ghaziabad </li>
          <li>Content Marketing Jobs in Ghaziabad </li>
          <li>Email Marketing Jobs in Ghaziabad </li>
          <li>Digital Marketing Analyst Jobs in Ghaziabad </li>
          <li>Google Ads Expert Jobs in Ghaziabad </li>
          <li>Digital Marketing Internships in Ghaziabad </li>
          <li>Performance Marketing Jobs in Ghaziabad </li>
          <li>Freelance Digital Marketing Jobs in Ghaziabad </li>
        </ul>

        <p className="text-gray-600">
          Start your journey in the digital world with{" "}
          <strong>jobsindelhincr.in</strong> — your trusted job portal to find
          verified <strong>digital marketing job openings</strong> in Ghaziabad.
          No registration required — apply directly to top companies today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default DigitalMarketingJobsGhazi;
